module.exports = __webpack_public_path__ + "img/inception3.5b6f5d2f.png";